import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services';

export function logoutGuard(): CanActivateFn {
  return (route, state) => {
    const authenticationService = inject(AuthenticationService);
    authenticationService.signOut();
    const router = inject(Router);
    return router.navigate(['/']);
  };
}
